var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 7.90449C18.4999 7.63928 18.3946 7.38492 18.207 7.19739C18.0195 7.00985 17.7652 6.90449 17.4999 6.90449L9.49994 6.85449C9.23472 6.85449 8.98037 6.95985 8.79283 7.14739C8.6053 7.33492 8.49994 7.58928 8.49994 7.85449C8.49994 8.11971 8.6053 8.37406 8.79283 8.5616C8.98037 8.74914 9.23472 8.85449 9.49994 8.85449H15.0599L6.78994 17.1445C6.69621 17.2375 6.62182 17.3481 6.57105 17.4699C6.52028 17.5918 6.49414 17.7225 6.49414 17.8545C6.49414 17.9865 6.52028 18.1172 6.57105 18.2391C6.62182 18.3609 6.69621 18.4715 6.78994 18.5645C6.8829 18.6582 6.9935 18.7326 7.11536 18.7834C7.23722 18.8342 7.36793 18.8603 7.49994 18.8603C7.63195 18.8603 7.76266 18.8342 7.88452 18.7834C8.00638 18.7326 8.11698 18.6582 8.20994 18.5645L16.4999 10.2745V15.8545C16.4999 16.1197 16.6053 16.3741 16.7928 16.5616C16.9804 16.7491 17.2347 16.8545 17.4999 16.8545C17.7652 16.8545 18.0195 16.7491 18.207 16.5616C18.3946 16.3741 18.4999 16.1197 18.4999 15.8545V7.90449Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.c9e433acccefa49143c83ac1e3954903.svg";
export { ForwardRef as ReactComponent };